export default function(date, invoice) {
  if (!date) return true;
  if (typeof date !== 'string') return false;

  const lines = invoice.lines || [];
  const dates = lines.map(l => l.date).filter(v => v);
  const max = dates.reduce((a, b) => (a.localeCompare(b) > 0 ? a : b), date);
  return max === date;
}
